import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import MaskedInput from "react-text-mask";

import "./TextInput.scss";

export const TextInput = ({
    className,
    classNameTextarea,
    id,
    label,
    error,
    success,
    disabled,
    helperText,
    placeholder,
    hideHelpText,
    type = "text",
    mask,
    rows,
    formProps,
    ...restProps
}) => {
    const inputId = id || uuidv4();

    const classes = classNames(
        "text-field",
        { "text-field--disabled": disabled },
        { "text-field--error": error },
        { "text-field--success": success },
        className
    );

    if(restProps.type === "hidden") {
        return <input {...restProps} />;
    }

    const InputComponent = type === "number" || !mask ? "input" : MaskedInput;

    const commonProps = {
        id: inputId,
        className: "text-field__input",
        type,
        disabled,
        mask,
        placeholder: placeholder || "",
        ...restProps
    };

    return (
        <div className={classes}>
            { label && (
                <label
                    htmlFor={inputId}
                    className="text-field__label"
                >
                    {label}
                </label>
            )}

            { rows ? (
                <textarea
                    {...commonProps}
                    className={
                        classNames(
                            "text-field__input",
                            "text-field--textarea",
                            classNameTextarea
                        )
                    }
                    rows={rows}
                />
            ) : (
                <InputComponent {...commonProps} />
            ) }

            { !hideHelpText && <div className="text-field__helper-text">{error || helperText}</div> }
        </div>
    );
};

TextInput.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.object,
    inputClassName: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    handleChange: PropTypes.func,
    meta: PropTypes.object
};
